import { IRepo } from "@/types";
import MultiLibrary from "./multi";

export const lib: IRepo = new MultiLibrary();
